import { render, staticRenderFns } from "./BlogNext.vue?vue&type=template&id=5596b680"
import script from "./BlogNext.vue?vue&type=script&lang=ts"
export * from "./BlogNext.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports